<ucs-sidebar-template (hideSidebar)="onToggleSidebar()">
    <div class="pb-2 pt-2">
        <div class="row mt-0"></div>

        <!--full-text-search-->
        <ucs-vehicle-identification-full-text-search (fulltextSearch)="emitFulltextSearch($event)">
        </ucs-vehicle-identification-full-text-search>

        <!--category-->
        <div class="mt-2 mb-2">
            @if (isEnforcedMaintenanceEnabled) {
                <div>
                    @for (category of categories; track category) {
                        <div>
                            @if (category === 'LONGTIME_PENDING' && categories.length > 1) {
                                <div class="row mt-1">
                                    <div class="col-12">
                                        <hr class="hr mb-3">
                                    </div>
                                </div>
                            }
                            <div (click)="changeCategory(category)"
                                 [ngClass]="{'active-category':category === vehicleMaintenanceState.activeCategory}"
                                 class="mt-2 category">
                                <ucs-icon [size]="24" [id]="'maintenance-search-' + category" [shape]="category"
                                          class="ms-1 me-1 grey"></ucs-icon>
                                <label
                                        [attr.data-cy]="'vehicle-maintenance.sidebar.' + category">{{ 'vehicle-maintenance.sidebar.' + category | translate }}</label>
                            </div>
                        </div>
                    }
                </div>
            } @else {
                @for (category of categories; track category) {
                    <div (click)="changeCategory(category)"
                         [ngClass]="{'active-category':category === vehicleMaintenanceState.activeCategory}"
                         class="mt-2 category"
                    >
                        @if (category !== 'LONGTIME_PENDING') {
                            <div>
                                <ucs-icon [size]="24" [id]="'maintenance-search-' + category" [shape]="category"
                                          class="ms-1 me-1 grey"></ucs-icon>
                                <label
                                        [attr.data-cy]="'vehicle-maintenance.sidebar.' + category">{{ 'vehicle-maintenance.sidebar.' + category | translate }}</label>
                            </div>
                        }
                    </div>
                }
            }

        </div>
    </div>
</ucs-sidebar-template>